import { useEffect, useRef, useState } from "react";
import { auth } from "../../firebase";
import companiesQuery from "../../firestore/Companies.query";
import { MenuSettingEditItme, MenuSettings } from "../../model/MenuSettings";
import Button from "../../components/button/Button";
import { Spiner } from "../../components/spinner/Spiner";
import DraggableTable, { GridCol, GridRow } from "../../components/table/DraggableTable";
import { SystemMenus } from "../../model/SystemMenus";
import { VideoMenus } from "../../model/VideoMenus";
import { MenuSettingModal } from "./MenuSettingModal";
import { LinkMenus } from "../../model/LinkMenus";
import { ImageModal } from "./ImageModal";
import smartPhoneImage from "../../assets/images/MenuSettingIamge.png"
import tabletImage from "../../assets/images/MenuSettingImageTablet.png"
import { BgImageSubTitleModal } from "./BgImageSubTitleModal";
import { SystemSetting } from "../../model/SystemSetting";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { useDispatch } from "react-redux";
import { ColorSelect } from "../../components/colorSelect/ColorSelect";
import { MessagingCommonFunctions } from "../../controller/MessagingCommonFunctionsController";
import { ConstMessage, ConstValue } from "../../config/const";
import { ThemeAndButtonModal } from "./ThemeAndButtonModal";

export const MenuSettingsPage = () => {

  const isDisabled = useRef(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isBgImageSubtitleOpen, setIsBgImageSubtitleOpen] = useState(false);
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [isDraggable, setIsDraggable] = useState(true);
  const [menuSettings, setMenuSettings] = useState<(MenuSettings & {name?: string, bgColor?: string, textColor?: string, colorName?: string})[]>([]);
  const [systemMenusList, setSystemMenusList] = useState<SystemMenus[]>([]);
  const [videoMenusList, setVideoMenusList] = useState<VideoMenus[]>([]);
  const [linkMenusList, setLinkMenusList] = useState<LinkMenus[]>([]);
  const [editItem, setEditItem] = useState<MenuSettingEditItme | undefined>();
  const [rowList, setRowList] = useState<GridRow[]>([]);
  const [imagePath, setImagePath] = useState<string>('');
  const [systemSetting, setSystemSetting] = useState<SystemSetting>();
  const [base64Image, setBase64Image] = useState<string>('');
  const [isLoad, setIsLoad] = useState<boolean>(true);
  const [isColorChanged, setIsColorChanged] = useState<boolean>(false);
  const [isThemeAndButtonOpen, setIsThemeAndButtonOpen] = useState(false);

  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;

  const messageCommonFunctions = new MessagingCommonFunctions();

  const dispatch = useDispatch();

  useEffect(() => {
    const f = async () => {
      setIsLoad(true);
      // メニュー設定取得
      const menuSettings: (MenuSettings & {name?: string, bgColor?: string, textColor?: string, colorName?: string})[] =
        await companiesQuery.getMenuSettings(currentUser?.tenantId!);
      const menuSettingWithName = await Promise.all(menuSettings.map(async (menu) => {
        switch (menu.menuType) {
          case 'system':
            const systemMenus = await companiesQuery.getSystemMenus(currentUser?.tenantId!, menu.menuNo);
            if(systemMenus !== undefined){
              menu.name = systemMenus.name;
              menu.colorName = systemMenus.colorName;
              menu.bgColor = systemMenus.bgColor;
              menu.textColor = systemMenus.textColor;
            }
            break;
          case 'application':
            const linkMenus = await companiesQuery.getLinkMenus(currentUser?.tenantId!, menu.menuNo);
            if(linkMenus !== undefined){
              menu.name = linkMenus.name;
              menu.colorName = linkMenus.colorName;
              menu.bgColor = linkMenus.bgColor;
              menu.textColor = linkMenus.textColor;
            }
            break;
          case 'movie':
            const videoMenus = await companiesQuery.getVideoMenus(currentUser?.tenantId!, menu.menuNo);
            if(videoMenus !== undefined){
              menu.name = videoMenus.name;
              menu.colorName = videoMenus.colorName;
              menu.bgColor = videoMenus.bgColor;
              menu.textColor = videoMenus.textColor;
            }
            break;
        }
        return menu;
      }));
      while(menuSettingWithName.length < 8) {
        menuSettingWithName.push({
          id: "",
          displayOrder: menuSettingWithName.length.toString(),
          enableFlag: false,
          menuType: undefined,
          menuNo: "",
          name: ""
        });
      }
      setMenuSettings(menuSettingWithName);

      // システム設定取得
      const systemSetting = await companiesQuery.getSystemSetting(currentUser?.tenantId!);
      setSystemSetting(systemSetting);
      const useColorSet = systemSetting?.colorTheme === 'lightColor' ? ConstValue.lightColor : ConstValue.darkColor;

      const rowList: GridRow[] = menuSettingWithName.map((menu, index) => {
        const colorClassName = useColorSet.filter((item) => item.colorName === menu.colorName).at(0) ?? useColorSet.at(0);
        const textColor = systemSetting?.colorTheme === 'lightColor' ? 'text-gray-700' : menu.colorName === 'white' ? 'text-gray-700' : 'text-white';
        return {
          rowData: {
            id: menu.id,
            menuNo: menu.menuNo,
            name: menu.name
              ? (
                <div className={`${colorClassName?.className} p-2 rounded-md text-center font-bold ${textColor} ${menu.colorName === 'white' ? 'border border-gray-100' : ''}`}>
                  {menu.name}
                </div>
              )
              : (<></>),
            type: menu.menuType ?? '',
            bgColor: (menu.name !== '' && menu.name !== undefined)
              ? (<ColorSelect
                  key={menu.id}
                  colorSetList={useColorSet}
                  size={"lg"}
                  onClick={(color: string) => onChangeColor(menu, color)}
                  value={menu.colorName ?? useColorSet[0].colorName}
                />)
              : (<></>),
            control: (index !== 0)
              ? (<Button onClick={() => {
                  setEditItem({
                    menuNo: menu.menuNo,
                    menuType: menu.menuType,
                    menuIndex: index + 1,
                  })
                  toggle();
                }} children={"編集"} />)
              : (<></>)
          },
          draggable: index !== 0 && (menu.name !== '' && menu.name !== undefined)
        };
      });
      setRowList(rowList);

      setIsLoad(false);
    };
    f();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.tenantId, isDraggable, isColorChanged, isOpen]);

  useEffect(() => {
    const f = async () => {
      // システムメニュー一覧取得
      const systemMenusList = await companiesQuery.getSystemMenusList(currentUser?.tenantId!);
      setSystemMenusList(systemMenusList);

      // // 動画メニュー一覧取得
      const videoMenusList = await companiesQuery.getVideoMenusList(currentUser?.tenantId!);
      setVideoMenusList(videoMenusList);

      // アプリ連携メニュー一覧取得
      const linkMenusList = await companiesQuery.getLinkMenusList(currentUser?.tenantId!);
      setLinkMenusList(linkMenusList);
    };
    f();
  },[currentUser?.tenantId]);

  useEffect(() => {
    const f = async () => {
      // システム設定取得
      const systemSetting = await companiesQuery.getSystemSetting(currentUser?.tenantId!);
      setSystemSetting(systemSetting);

      if(systemSetting){
        setBase64Image(systemSetting.image);
      }
    };
    f();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[currentUser?.tenantId, isBgImageSubtitleOpen, isThemeAndButtonOpen]);

  const onChangeColor = async (
    menu: MenuSettings & {
      name?: string | undefined;
      colorName?: string | undefined;
      bgColor?: string | undefined;
      textColor?: string | undefined;
    },
    color: string,
    isTheme?: boolean
  ) => {
    // ボタン色変更
    // システム設定取得
    const systemSetting = await companiesQuery.getSystemSetting(currentUser?.tenantId!);
    const theme = systemSetting?.colorTheme === 'lightColor' ? ConstValue.lightColor : ConstValue.darkColor;
    // ボタン色の設定（未設定の場合はピンク）
    const bgColor = theme.filter((item) => item.colorName === color).at(0) ?? theme.at(0);
    // 文字色の設定（ボタン色が白の場合は必ず黒）
    const textColor = bgColor?.colorName === 'white' ? 'black' :
                                                       systemSetting?.colorTheme === 'lightColor' ? 'black' : 'white';
    const updateMenu = {
      id: menu.menuNo,
      colorName: color,
      bgColor: bgColor?.hex,
      textColor: textColor,
    }
    switch(menu.menuType) {
      case 'system':
        await companiesQuery.updateSystemMenus(currentUser?.tenantId!, updateMenu);
        break;
      case 'application':
        await companiesQuery.updateLinkMenus(currentUser?.tenantId!, updateMenu);
        break;
    }
    if(!isTheme){
      setIsColorChanged(!isColorChanged);
    }
  }

  const columns: GridCol[] = [
    {
      field: "name",
      headerName: "表示名",
      style: "",
    },
    {
      field: "type",
      headerName: "種別",
      style: "",
    },
    {
      field: "bgColor",
      headerName: "ボタン色",
      style: "",
    },
    {
      field: "control",
      headerName: "編集",
      style: "",
    },
  ];

  const onSubmitHandler = async (selectedItem: MenuSettingEditItme) => {
    if(!isDisabled.current){
      try {
        isDisabled.current = true;
        if(selectedItem.menuNo === 'delete') {
          await companiesQuery.deleteMenuSetting(currentUser?.tenantId!, menuSettings[selectedItem.menuIndex - 1].id);
          toggle();
          dispatch(alertOpen(AlertValue("トップから非表示にしました", "success")));
          isDisabled.current = false;
          return
        }
        let type: "system" | "application" | "movie" | undefined = undefined;
        if(systemMenusList.filter((item) => item.id === selectedItem.menuNo).length > 0){
          type = 'system';
        }
        if(videoMenusList.filter((item) => item.id === selectedItem.menuNo).length > 0){
          type = 'movie';
        }
        if(linkMenusList.filter((item) => item.id === selectedItem.menuNo).length > 0){
          type = 'application';
        }
        const menuSetting: MenuSettings = {
          id: menuSettings[selectedItem.menuIndex - 1].id,
          displayOrder: selectedItem.menuIndex.toString(),
          enableFlag: selectedItem.menuNo.length > 0,
          menuType: type,
          menuNo: selectedItem.menuNo
        };
        const resolve = await companiesQuery.upsertMenuSetting(currentUser?.tenantId!, menuSetting);
        if(resolve.displayOrder !== "0"){
          dispatch(alertOpen(AlertValue("登録しました。", "success")));
          toggle();
          isDisabled.current = false;
        }
      } catch (err: any) {
        console.error(err);
        dispatch(alertOpen(AlertValue("登録に失敗しました。", "danger")));
        isDisabled.current = false;
      }
    }
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const draggable = async (rowDatas: any) => {
    try{
      const updateMenuSettings = rowDatas.map((data: any, index: number): MenuSettings => {
        const rowData = data.rowData;
        return {
          id: rowData.id,
          displayOrder: (index + 1).toString(),
          enableFlag: rowData.id !== undefined,
          menuType: rowData.type,
          menuNo: rowData.menuNo,
        }
      });
      const resolve = await companiesQuery.upsertMenuSettings(currentUser?.tenantId!, updateMenuSettings);
      if(resolve.length > 0){
        setIsDraggable(!isDraggable);
      }
    } catch (err: any) {
      console.error(err);
    }
  };

  // イメージ画像
  const imageToggle = () => {
    setIsImageOpen(!isImageOpen);
  };

  // 背景画像とタイトル
  const bgImageSubtitleToggle = () => {
    setIsBgImageSubtitleOpen(!isBgImageSubtitleOpen);
  };

  // テーマとボタン
  const themeAndButtonToggle = () => {
    setIsThemeAndButtonOpen(!isThemeAndButtonOpen);
  };

  const onBgImageSubtitleSubmit = async (data: SystemSetting) => {
    if(!isDisabled.current){
      try{
        isDisabled.current = true;
        data.id = systemSetting?.id ?? '';
        data.image = base64Image ?? '';
        data.colorTheme = systemSetting?.colorTheme ?? '';
        if(data.subTitle === '' || data.subTitle === undefined){
          delete data.subTitle;
        };
        const resutl = await companiesQuery.upsertSystemSetting(currentUser?.tenantId!, data);
        setSystemSetting(resutl);
        if(resutl.id !== undefined){
          dispatch(alertOpen(AlertValue('保存しました。', "success")));
        }else{
          throw new Error();
        }
        bgImageSubtitleToggle();
        isDisabled.current = false;
      } catch (err: any){
        console.error(err);
        dispatch(alertOpen(AlertValue('保存に失敗しました。', "danger")));
        isDisabled.current = false;
      }
    }
  };

  const onThemeAndButtonSubmit = async (data: SystemSetting) => {
    if(!isDisabled.current){
      try{
        isDisabled.current = true;
        const result = await companiesQuery.upsertSystemSetting(currentUser?.tenantId!, data);
        setSystemSetting(result);
        if(result.id !== undefined){
          dispatch(alertOpen(AlertValue('保存しました。', "success")));
        }else{
          throw new Error();
        }
        themeAndButtonToggle();
        if (systemSetting?.colorTheme !== data.colorTheme) {
          // ボタン色（濃度）を変更した場合
          menuSettings.map(async (menu) => {
            await onChangeColor(menu, menu.colorName ?? '', true);
          })
          setIsColorChanged(!isColorChanged);
        }
        isDisabled.current = false;
      } catch (err: any){
        console.error(err);
        dispatch(alertOpen(AlertValue('保存に失敗しました。', "danger")));
        isDisabled.current = false;
      }
    }
  };

  const onSendImage = (file: File) => {
    if(!isDisabled.current){
      try{
        isDisabled.current = true;
        if(file.type !== 'image/jpeg' && file.type !== 'image/png'){
          dispatch(alertOpen(AlertValue(ConstMessage.ERR_UNSUPPORT_IMG_FILE_TYPE, "danger")));
          isDisabled.current = false;
          return;
        };
        messageCommonFunctions.imageFileToBase64Image(file, setBase64Image);

        dispatch(alertOpen(AlertValue("アップロードしました。", "success")));
        isDisabled.current = false;
      } catch (error: any){
        console.error(error);
        dispatch(alertOpen(AlertValue("アップロードに失敗しました", "danger")));
        isDisabled.current = false;
      }
    }
  };

  return (
    <div className="h-full">
      <div className="flex items-center space-x-4 p-6 justify-between">
        <h2 className="flex text-xl whitespace-nowrap font-semibold text-gray-900">
          トップ画面設定
        </h2>
        <div className={"flex space-x-2 items-center"}>
          <Button
            //children={"テーマとボタン表示設定"} //TODO 辰尻：テーマ実装までボタン名称を変更
            children={"ボタン設定"}
            size={"sm"}
            onClick={themeAndButtonToggle}
            disabled={isLoad}
          />
          <Button
            children={"背景画像とタイトル登録"}
            size={"sm"}
            onClick={bgImageSubtitleToggle}
            disabled={isLoad}
          />
          <Button
            children={"スマホレイアウト参考画像"}
            size={"sm"}
            outline
            color={"violet"}
            onClick={() => {
              setImagePath(smartPhoneImage);
              imageToggle();
            }}
          />
          <Button
            children={"タブレットレイアウト参考画像"}
            size={"sm"}
            outline
            color={"violet"}
            onClick={() => {
              setImagePath(tabletImage);
              imageToggle();
            }}
          />
        </div>
      </div>
      {isLoad === true ? <Spiner /> : (
      <div className={"px-6"}>
        <DraggableTable
          gridCol={columns}
          gridRow={rowList}
          dragEndHandle={draggable}
        />
        <ThemeAndButtonModal
          children={undefined}
          open={isThemeAndButtonOpen}
          toggle={themeAndButtonToggle}
          closeOnClickOutside={false}
          systemSetting={systemSetting}
          onSubmit={onThemeAndButtonSubmit}
        />
        <BgImageSubTitleModal
          children={undefined}
          open={isBgImageSubtitleOpen}
          toggle={bgImageSubtitleToggle}
          closeOnClickOutside={false}
          systemSetting={systemSetting}
          onSubmit={onBgImageSubtitleSubmit}
          onSendImage={onSendImage}
          base64Image={base64Image}
          setBase64Image={setBase64Image}
        />
        <MenuSettingModal
          children={undefined}
          open={isOpen}
          toggle={toggle}
          closeOnClickOutside={false}
          editItem={editItem}
          menuSettings={menuSettings}
          systemMenusList={systemMenusList}
          videoMenusList={videoMenusList}
          linkMenusList={linkMenusList}
          onSubmitHandler={onSubmitHandler}
        />
        <ImageModal
          children={undefined}
          open={isImageOpen}
          toggle={imageToggle}
          closeOnClickOutside={false}
          imagePath={imagePath}
        />
      </div>
    )}
    </div>
  );
};

